import { EbGetStoriesEditorMeta, EbGetStoriesEditorPayload } from 'types/store/EbGetStoriesEditor';
import { createAsyncReducer } from 'utils/Redux';

import { ebGetStoriesEditorActions } from '../actions';

export default createAsyncReducer<EbGetStoriesEditorMeta, EbGetStoriesEditorPayload>(ebGetStoriesEditorActions);
